import { Card } from 'components'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'

import helpers from 'helpers'

const Contact = ({ preRegistration }) => {
  return (
    <Card title="Contato">
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell width="25%">Nome</TableCell>
            <TableCell width="25%">Telefone</TableCell>
            <TableCell width="25%">E-mail</TableCell>
            <TableCell width="25%">Tipo</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell disableTooltip noOverFlow>
              {preRegistration?.responsibleUser?.name}
            </TableCell>
            <TableCell noOverFlow disableTooltip>
              {helpers.formatters.phone.number(
                preRegistration?.responsibleUser?.phone,
              )}
            </TableCell>
            <TableCell noOverFlow disableTooltip>
              {preRegistration?.responsibleUser?.email}
            </TableCell>
            <TableCell noOverFlow disableTooltip>
              Representante
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell disableTooltip noOverFlow>
              {preRegistration?.contactName || '-'}
            </TableCell>
            <TableCell noOverFlow disableTooltip>
              {helpers.formatters.phone.number(preRegistration?.phone)}
            </TableCell>
            <TableCell noOverFlow disableTooltip>
              {preRegistration?.email}
            </TableCell>
            <TableCell noOverFlow disableTooltip>
              Financeiro
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Card>
  )
}

export default Contact
